import { DateTime } from "luxon";

export const isUnderOneYearOld = (dobValue) => {
  if (!dobValue) return false;
  const dobDateTime = DateTime.isDateTime(dobValue)
    ? dobValue
    : DateTime.fromISO(dobValue);
  return (
    dobDateTime.isValid && DateTime.now().diff(dobDateTime, "years").years < 1
  );
};
